export default [
  {
    name: 'INDUSTRY_TYPE_BASE',
    value: 1
  }
]